import { render, staticRenderFns } from "./WordsDictation3Form.vue?vue&type=template&id=104674f8&"
import script from "./WordsDictation3Form.vue?vue&type=script&lang=js&"
export * from "./WordsDictation3Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports